import S from '../AdminSearchSelectPopup/AdminSearchSelectPopup.module.scss';
import React, {Dispatch, SetStateAction, useEffect, useState} from 'react';
import {fetchAdminCompanyList, getAdminOccupations, getAdminRegions} from '../../../repository/AdminRepository';

interface AdminSearchSelectPopupProps {
  searchType: 'region' | 'occupation' | 'company';
  onSelectFn: Function;
  setShowPopup: Dispatch<SetStateAction<boolean>>;
}

interface SearchDataType {
  id: number;
  name: string;
}

const AdminSearchSelectPopup = (props: AdminSearchSelectPopupProps) => {
  const { searchType, onSelectFn, setShowPopup } = props;
  const ADMIN_TOKEN = process.env.REACT_APP_IVY_ADMIN_TOKEN || '';
  const [dataList, setDataList] = useState<SearchDataType[]>([]);

  const [currentPage, setCurrentPage] = useState<number>(0);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [searchText, setSearchText] = useState<string>('');
  const maxPageButtons = 10;
  const currentPageGroup = Math.floor(currentPage / maxPageButtons);
  const startPage = currentPageGroup * maxPageButtons;
  const endPage = Math.min(startPage + maxPageButtons, totalPages);
  const pages = Array.from({ length: endPage - startPage }, (_, index) => startPage + index);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    fetchSearchList(searchType, searchText, page, 10);
  };

  const handleSearch = (e: any) => {
    setSearchText(e.target.value);
  };

  const fetchSearchList = (type: 'region' | 'occupation' | 'company', title: string, page: number, size: number) => {
    if (type === 'region') {
      getAdminRegions(title, page, size, ADMIN_TOKEN)
        .then((res) => {
          if (res && res.content) {
            setTotalElements(res.totalElements);
            setTotalPages(res.totalPages);
            setDataList(
              res.content.map((region) => {
                return {
                  id: region.id,
                  name: region.name,
                } as SearchDataType;
              }),
            );
          }
        })
        .catch((e) => console.error(e));
    } else if (type === 'occupation') {
      getAdminOccupations(title, page, size, ADMIN_TOKEN)
        .then((res) => {
          if (res && res.content) {
            setTotalElements(res.totalElements);
            setTotalPages(res.totalPages);
            setDataList(
              res.content.map((occupation) => {
                return {
                  id: occupation.id,
                  name: occupation.name,
                } as SearchDataType;
              }),
            );
          }
        })
        .catch((e) => console.error(e));
    } else if (type === 'company') {
      fetchAdminCompanyList(title, page, size, ADMIN_TOKEN)
          .then((res) => {
            if (res && res.content) {
              setTotalElements(res.totalElements);
              setTotalPages(res.totalPages);
              setDataList(
                  res.content.map((company) => {
                    return {
                      id: company.id,
                      name: company.name,
                    } as SearchDataType;
                  }),
              );
            }
          })
          .catch((e) => console.error(e));
    }
  };
  const handleSelect = (data: SearchDataType) => {
    let searchKey = '';
    if(searchType === 'region') {
      searchKey = 'regionId';
    }else if(searchType === 'occupation'){
      searchKey = 'occupationId';
    } else if(searchType === 'company'){
      searchKey = 'companyId';
    }
    onSelectFn(searchKey, data.id);
    setShowPopup(false); // 선택 후 팝업 닫기
  };

  useEffect(() => {
    if (searchType) {
      fetchSearchList(searchType, searchText, 0, 10);
    }
  }, [searchType]);

  return (
    <>
      <div className={S.popupOverlay}>
        <div className={S.popupContent}>
          <h1>검색 팝업</h1>
          <button className={S.closeButton} onClick={() => setShowPopup(false)}>
            X
          </button>
          <div className={S.search_container}>
            <input
              className={S.search_name}
              type="text"
              placeholder={searchType == 'region'? '지역명' : searchType === 'company'? '회사명' : '직종명'}
              value={searchText}
              onChange={handleSearch}
            />
            <div className={S.empty}></div>
            <button
              className={S.search_btn}
              onClick={() => {
                setCurrentPage(0);
                fetchSearchList(searchType, searchText, 0, 10)
              }}
            >
              검색
            </button>
          </div>
          <table className={S.table}>
            <thead>
              <tr>
                <th>ID</th>
                <th>이름</th>
              </tr>
            </thead>
            <tbody>
              {dataList.map((data) => (
                <tr key={data.id} onClick={() => handleSelect(data)}>
                  <td>{data.id}</td>
                  <td>{data.name}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className={S.pagination}>
            {currentPageGroup > 0 && (
              <button onClick={() => handlePageChange(startPage - 1)} className={S.page_button}>
                &lt; 10개
              </button>
            )}
            {pages.map((page) => (
              <button
                key={'popup_search_' + page}
                onClick={() => handlePageChange(page)}
                className={currentPage === page ? S.selected_button : S.page_button}
              >
                {page + 1}
              </button>
            ))}
            {currentPageGroup < Math.ceil(totalPages / maxPageButtons) - 1 && (
              <button onClick={() => handlePageChange(endPage)} className={S.page_button}>
                10개 &gt;
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminSearchSelectPopup;
